// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   AccueilDashboard.css — Tableau de bord QLIO Manager
   La sidebar est gérée par AppSidebar.css
   ============================================================ */

/* Layout principal */
.accueil-layout {
    display: flex;
    height: 100vh;
    overflow: hidden;
    background: var(--bg);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* ---- CONTENU PRINCIPAL ---- */
.accueil-main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: 100vh;
    overflow: hidden;
}

/* Barre de titre */
.accueil-topbar {
    color: white;
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    position: sticky;
    top: 0;
    z-index: 50;
    /* background défini via inline style (couleur module) */
}

.accueil-topbar-title {
    font-size: 1.05rem;
    font-weight: 700;
}

.accueil-topbar-sub {
    font-size: 0.8rem;
    opacity: 0.75;
    margin-top: 2px;
}

.accueil-topbar-right {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 0.85rem;
}

/* Corps */
.accueil-body {
    padding: 16px 24px;
    flex: 1 1;
    overflow-y: auto;
}

/* ---- STATS RÉSUMÉ ---- */
.accueil-stats-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
    margin-bottom: 20px;
}

.stat-card {
    background: var(--card);
    border-radius: 10px;
    padding: 12px 14px;
    border: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    cursor: grab;
    transition: box-shadow 0.15s, transform 0.15s, opacity 0.15s;
    user-select: none;
}

.stat-card:active {
    cursor: grabbing;
}

.stat-card-drag-over {
    box-shadow: 0 0 0 2px #2563eb;
    transform: scale(1.02);
}

.stat-card-drag-handle {
    font-size: 1rem;
    color: #cbd5e1;
    cursor: grab;
    flex-shrink: 0;
}

/* Carte Planning — cliquable, accent bleu */
.stat-card-planning {
    cursor: pointer;
    border-color: #bfdbfe;
    background: #f0f7ff;
}

.stat-card-planning:hover {
    box-shadow: 0 4px 12px rgba(37,99,235,0.15);
    border-color: #93c5fd;
}

.stat-card-icon {
    font-size: 1.4rem;
    flex-shrink: 0;
}

.stat-card-value {
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--primary);
    line-height: 1;
}

.stat-card-label {
    font-size: 0.72rem;
    color: var(--secondary);
    margin-top: 2px;
}

.stat-card-planning-indicators {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 1;
}

.stat-card-planning-indicator {
    flex: 1 1;
    text-align: center;
}

.stat-card-planning-separator {
    width: 1px;
    height: 32px;
    background: #bfdbfe;
    flex-shrink: 0;
}

/* ---- SECTION FORMATION 🚧 ---- */
.section-dev-overlay-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.section-dev-badge {
    font-size: 0.9rem;
}

.niveaux-grid-dev {
    opacity: 0.45;
    cursor: not-allowed;
    pointer-events: none;
}

/* ---- GRILLE NIVEAUX ---- */
.accueil-section-title {
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: var(--secondary);
    margin-bottom: 12px;
}

.niveaux-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.niveau-card {
    background: var(--card);
    border-radius: 12px;
    border: 1px solid var(--border);
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}

.niveau-card-header {
    padding: 10px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid var(--border);
}

.niveau-badge {
    font-size: 0.75rem;
    font-weight: 700;
    color: white;
    padding: 3px 10px;
    border-radius: 6px;
    letter-spacing: 0.5px;
}

.niveau-card-nom {
    font-size: 0.9rem;
    font-weight: 600;
    color: #1e293b;
}

.niveau-card-body {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1px;
    background: var(--border);
}

.sous-niveau-cell {
    background: var(--card);
    padding: 12px 14px;
}

.sous-niveau-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
}

.sous-niveau-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.sous-niveau-code {
    font-size: 0.82rem;
    font-weight: 600;
    color: #1e293b;
}

.sous-niveau-effectif {
    font-size: 0.75rem;
    color: var(--secondary);
    margin-left: auto;
}

/* ---- VIGNETTES URGENCE ---- */
.vignettes-zone {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.vignette {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 500;
}

.vignette-urgent {
    background: #fef2f2;
    color: #dc2626;
    border: 1px solid #fecaca;
}

.vignette-warn {
    background: #fffbeb;
    color: #d97706;
    border: 1px solid #fde68a;
}

.vignette-avenir {
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.vignette-done {
    background: #f0fdf4;
    color: #16a34a;
    border: 1px solid #bbf7d0;
}

.vignette-neutre {
    background: #f8fafc;
    color: #94a3b8;
    border: 1px solid var(--border);
    font-weight: 400;
    font-style: italic;
}

.vignette-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    flex-shrink: 0;
}

.vignette-text {
    flex: 1 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ---- SECTION VIGNETTES GLOBALES ---- */
.accueil-vignettes-section {
    margin-top: 24px;
}

.vignettes-globales-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
}

.vignette-module-card {
    background: var(--card);
    border-radius: 10px;
    border: 1px solid var(--border);
    padding: 14px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.vignette-module-title {
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--secondary);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}

/* ---- CHARGEMENT / ERREUR ---- */
.accueil-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px;
    color: var(--secondary);
    gap: 12px;
}

.accueil-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid var(--border);
    border-top-color: var(--primary);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* ---- CARTE PLANNING ANNUEL ---- */
.module-card-planning {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    border-radius: 12px;
    padding: 16px;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
    color: white;
    grid-column: span 2;
}

.module-card-planning:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
}

.module-card-planning-header {
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    opacity: 0.9;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
}

.module-card-planning-stats {
    display: flex;
    gap: 24px;
}

.module-planning-stat {
    flex: 1 1;
}

.module-planning-stat-value {
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
}

.module-planning-stat-label {
    font-size: 0.7rem;
    opacity: 0.75;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.module-card-planning-hint {
    margin-top: 14px;
    font-size: 0.72rem;
    opacity: 0.55;
    text-align: right;
}

/* ---- OVERLAY 🚧 modules en développement ---- */
.vignette-module-dev {
    position: relative;
    opacity: 0.55;
    cursor: not-allowed;
    pointer-events: none;
}

.vignette-dev-overlay {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 1.1rem;
    line-height: 1;
    pointer-events: none;
    z-index: 2;
}

`, "",{"version":3,"sources":["webpack://./src/components/AccueilDashboard.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE,qBAAqB;AACrB;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,sEAAsE;AAC1E;;AAEA,gCAAgC;AAChC;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sCAAsC;IACtC,YAAY;IACZ,4DAA4D;IAC5D,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,yCAAyC;AACzC;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,oCAAoC;AACpC;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,uDAAuD;IACvD,4CAA4C;IAC5C,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,UAAU;AACd","sourcesContent":["/* ============================================================\n   AccueilDashboard.css — Tableau de bord QLIO Manager\n   La sidebar est gérée par AppSidebar.css\n   ============================================================ */\n\n/* Layout principal */\n.accueil-layout {\n    display: flex;\n    height: 100vh;\n    overflow: hidden;\n    background: var(--bg);\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* ---- CONTENU PRINCIPAL ---- */\n.accueil-main {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    height: 100vh;\n    overflow: hidden;\n}\n\n/* Barre de titre */\n.accueil-topbar {\n    color: white;\n    padding: 12px 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    /* background défini via inline style (couleur module) */\n}\n\n.accueil-topbar-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n}\n\n.accueil-topbar-sub {\n    font-size: 0.8rem;\n    opacity: 0.75;\n    margin-top: 2px;\n}\n\n.accueil-topbar-right {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    font-size: 0.85rem;\n}\n\n/* Corps */\n.accueil-body {\n    padding: 16px 24px;\n    flex: 1;\n    overflow-y: auto;\n}\n\n/* ---- STATS RÉSUMÉ ---- */\n.accueil-stats-row {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n.stat-card {\n    background: var(--card);\n    border-radius: 10px;\n    padding: 12px 14px;\n    border: 1px solid var(--border);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n    cursor: grab;\n    transition: box-shadow 0.15s, transform 0.15s, opacity 0.15s;\n    user-select: none;\n}\n\n.stat-card:active {\n    cursor: grabbing;\n}\n\n.stat-card-drag-over {\n    box-shadow: 0 0 0 2px #2563eb;\n    transform: scale(1.02);\n}\n\n.stat-card-drag-handle {\n    font-size: 1rem;\n    color: #cbd5e1;\n    cursor: grab;\n    flex-shrink: 0;\n}\n\n/* Carte Planning — cliquable, accent bleu */\n.stat-card-planning {\n    cursor: pointer;\n    border-color: #bfdbfe;\n    background: #f0f7ff;\n}\n\n.stat-card-planning:hover {\n    box-shadow: 0 4px 12px rgba(37,99,235,0.15);\n    border-color: #93c5fd;\n}\n\n.stat-card-icon {\n    font-size: 1.4rem;\n    flex-shrink: 0;\n}\n\n.stat-card-value {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: var(--primary);\n    line-height: 1;\n}\n\n.stat-card-label {\n    font-size: 0.72rem;\n    color: var(--secondary);\n    margin-top: 2px;\n}\n\n.stat-card-planning-indicators {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex: 1;\n}\n\n.stat-card-planning-indicator {\n    flex: 1;\n    text-align: center;\n}\n\n.stat-card-planning-separator {\n    width: 1px;\n    height: 32px;\n    background: #bfdbfe;\n    flex-shrink: 0;\n}\n\n/* ---- SECTION FORMATION 🚧 ---- */\n.section-dev-overlay-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.section-dev-badge {\n    font-size: 0.9rem;\n}\n\n.niveaux-grid-dev {\n    opacity: 0.45;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n/* ---- GRILLE NIVEAUX ---- */\n.accueil-section-title {\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    color: var(--secondary);\n    margin-bottom: 12px;\n}\n\n.niveaux-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.niveau-card {\n    background: var(--card);\n    border-radius: 12px;\n    border: 1px solid var(--border);\n    overflow: hidden;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n}\n\n.niveau-card-header {\n    padding: 10px 16px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    border-bottom: 1px solid var(--border);\n}\n\n.niveau-badge {\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: white;\n    padding: 3px 10px;\n    border-radius: 6px;\n    letter-spacing: 0.5px;\n}\n\n.niveau-card-nom {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.niveau-card-body {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 1px;\n    background: var(--border);\n}\n\n.sous-niveau-cell {\n    background: var(--card);\n    padding: 12px 14px;\n}\n\n.sous-niveau-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 8px;\n}\n\n.sous-niveau-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.sous-niveau-code {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.sous-niveau-effectif {\n    font-size: 0.75rem;\n    color: var(--secondary);\n    margin-left: auto;\n}\n\n/* ---- VIGNETTES URGENCE ---- */\n.vignettes-zone {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.vignette {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 8px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 500;\n}\n\n.vignette-urgent {\n    background: #fef2f2;\n    color: #dc2626;\n    border: 1px solid #fecaca;\n}\n\n.vignette-warn {\n    background: #fffbeb;\n    color: #d97706;\n    border: 1px solid #fde68a;\n}\n\n.vignette-avenir {\n    background: #eff6ff;\n    color: #2563eb;\n    border: 1px solid #bfdbfe;\n}\n\n.vignette-done {\n    background: #f0fdf4;\n    color: #16a34a;\n    border: 1px solid #bbf7d0;\n}\n\n.vignette-neutre {\n    background: #f8fafc;\n    color: #94a3b8;\n    border: 1px solid var(--border);\n    font-weight: 400;\n    font-style: italic;\n}\n\n.vignette-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: currentColor;\n    flex-shrink: 0;\n}\n\n.vignette-text {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ---- SECTION VIGNETTES GLOBALES ---- */\n.accueil-vignettes-section {\n    margin-top: 24px;\n}\n\n.vignettes-globales-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 14px;\n}\n\n.vignette-module-card {\n    background: var(--card);\n    border-radius: 10px;\n    border: 1px solid var(--border);\n    padding: 14px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.vignette-module-title {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n/* ---- CHARGEMENT / ERREUR ---- */\n.accueil-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px;\n    color: var(--secondary);\n    gap: 12px;\n}\n\n.accueil-spinner {\n    width: 32px;\n    height: 32px;\n    border: 3px solid var(--border);\n    border-top-color: var(--primary);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n/* ---- CARTE PLANNING ANNUEL ---- */\n.module-card-planning {\n    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n    border-radius: 12px;\n    padding: 16px;\n    cursor: pointer;\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);\n    color: white;\n    grid-column: span 2;\n}\n\n.module-card-planning:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);\n}\n\n.module-card-planning-header {\n    font-size: 0.85rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    opacity: 0.9;\n    margin-bottom: 14px;\n    display: flex;\n    align-items: center;\n}\n\n.module-card-planning-stats {\n    display: flex;\n    gap: 24px;\n}\n\n.module-planning-stat {\n    flex: 1;\n}\n\n.module-planning-stat-value {\n    font-size: 1.8rem;\n    font-weight: 700;\n    line-height: 1;\n    margin-bottom: 4px;\n}\n\n.module-planning-stat-label {\n    font-size: 0.7rem;\n    opacity: 0.75;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.module-card-planning-hint {\n    margin-top: 14px;\n    font-size: 0.72rem;\n    opacity: 0.55;\n    text-align: right;\n}\n\n/* ---- OVERLAY 🚧 modules en développement ---- */\n.vignette-module-dev {\n    position: relative;\n    opacity: 0.55;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n.vignette-dev-overlay {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    font-size: 1.1rem;\n    line-height: 1;\n    pointer-events: none;\n    z-index: 2;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
